import moment from "moment";
import React from "react";

const PressItem = ({ item }) => {
  const logo = item.mOLogoUrl ? (
    <img className="pub-logo" src={item.mOLogoUrl} alt="logo" />
  ) : null;
  return (
    <li>
      <div className="col-xs-4 col-xxs-16">
        <div className="logo-wrapper">{logo}</div>
      </div>
      <div className="col-xs-12 col-xxs-16">
        <a href={item.url} target="_blank">
          <h6>{item.title}</h6>
        </a>
        <div className="by-line">
          {moment(item.date).utc().format("MMMM Do, YYYY")}
        </div>
      </div>
      <div className="clearfix">&nbsp;</div>
    </li>
  );
};

export default PressItem;



// WEBPACK FOOTER //
// ./src/components/press/press-item.js